export const ACCOUNT_NUMBER = "account_number";
export const ADD = "Add";
export const ADDRESS = "address";
export const AIRCRAFT_ID = "aircraft_id";
export const ADJUSTMENT = "adjustment";
export const ADJUSTMENT_TYPE = "adjustment_type";
export const AS_REMOVED = "as_removed";
export const ATTACHMENT_TYPE = "attachment_type";
export const ATTACHMENTS = "attachments";
export const AUTO_ADJUST_SRP = "auto_adjust_srp";
export const AWB_NUMBER = "awb_number";
export const BEYOND_REPAIR = "beyond_econ_repair";
export const BUY_AR_FOR_STOCK = "buyer_ar_for_stock";
export const BUYER_CREDIT_PCT = "buyer_credit_pct";
export const CANCELLED = "cancelled";
export const CREDIT_REQUESTED = "credit_requested";
export const CAN_EXCHANGE = "can_exchange";
export const CARRIER = "carrier";
export const CLEAR_FILTERS_TEXT = "Clear Filters - Show All";
export const CODE = "code";
export const COST = "cost";
export const CONSIGNOR_PERCENTAGE = "consignor_percentage";
export const CREATED_BY_ID = "created_by_id";
export const CREATED_AT = "created_at";
export const CREATED_BY = "created_by";
export const CUSTOMER_PO = "customer_po";
export const CUSTOMER_PURCHASE_ORDER_NUMBER = "customer_purchase_order_number";
export const DAYS = "days";
export const DEFAULT_HAZMAT_FEE = "default_hazmat_fee";
export const DEFAULT_NO_FAULT_FOUND_FEE = "default_no_fault_found_fee";
export const EXCHANGE_CREDIT_PCT = "exchange_credit_pct";
export const FREIGHT_COMPLETE_RESTRICTION = "freight_complete_restriction";
export const FUZZY_SIMILARITY_PERCENT = "fuzzy_similarity_percent";
export const LABEL_SIZE = "label_size";
export const MIN_MANAGED_REPAIR_FEE = "min_managed_repair_fee";
export const EXPECTED_QUANTITY = "expected_quantity";
export const FILE_SIZE = "file_size";
export const FILE_URL = "file_url";
export const FOB = "fob";
export const INVOICED = "invoiced";
export const QUANTITY = "quantity";
export const QUANTITY_RECEIVED = "quantity_received";
export const COMPANY_ID = "company_id";
export const CONTACT_ID = "contact_id";
export const DISABLED = "disabled";
export const DISABLE_QB_SYNC = "disable_qb_sync";
export const ENABLED = "enabled";
export const END_DATE = "end_date";
export const EXCHANGE_CORE_DUE_DAYS = "exchange_core_due_days";
export const FILTERS = "filters";
export const ID = "id";
export const INSPECTED = "inspected";
export const INVENTORY_ACCOUNT = "inventory_account";
export const INVENTORY_ID = "inventory_id";
export const LINE_ITEMS = "line_items";
export const LOGO_URL = "logo_url";
export const MARKUP = "markup";
export const MINIMUM_EXCHANGE_SRP = "minimum_exchange_srp";
export const MINIMUM_REPAIR_FEE = "minimum_repair_fee";
export const MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION =
  "min_outright_value_for_exchange_consideration";
export const MONTH = "month";
export const MONTHS = "months";
export const NEW = "new_item";
export const NON_QUALIFIER = "NON_QUALIFIER";
export const NOTES = "notes";
export const NOT_RECEIVED = "not_received";
export const OUTRIGHT_SALE = "outright_sale";
export const OVERHAULED = "overhauled";
export const PAYMENT_TERMS = "payment_terms";
export const PURCHASE_ORDERS_QUICKBOOKS_TYPE =
  "purchase_orders_quickbooks_type";

export const QTY = "qty";
export const QUICKBOOKS_INVENTORY_TRACKING = "quickbooks_inventory_tracking";
export const QUICKBOOKS_CUSTOMER_PURCHASE_FIELD =
  "quickbooks_customer_purchase_field";
export const REDUCE_COST_AT_SALE = "reduce_cost_at_sale";
export const REDUCE_REPAIR_COST_AT_SALE = "reduce_repair_cost_at_sale";
export const RECEIVED = "received";
export const REFERENCE_NUMBER = "reference_number";
export const REFERENCE_NUMBER_LABEL = "Ref #";
export const REFERENCE_RECORD_LINE_ITEM_TYPE =
  "reference_record_line_item_type";
export const REPAIRED = "repaired";
export const REPAIRS_FROM_EMAIL = "repairs_from_email";
export const RESERVE_FOR_SELLER_ID = "reserve_for_seller_id";
export const SERVICEABLE_TOOLING = "serviceable_tooling";
export const SETTINGS = "settings";
export const SENT_EMAIL = "sent_email";
export const SHIPPING_OPTIONS = "shipping_options";
export const SHIPPING_TYPE = "shipping_type";
export const SHIPPED = "shipped";
export const SHIPPING_ADDRESS = "shipping_address";
export const SHIPPING_METHOD = "shipping_method";
export const SHIP_TO = "ship_to";
export const SHIP_TO_SHIPPING_METHOD = "ship_to_shipping_method";
export const SHIP_TO_TYPE = "ship_to_type";
export const SHIP_TO_CUSTOMER_ADDRESS_ID = "ship_to_customer_address_id";
export const SHIP_TO_COMPANY_ID = "ship_to_company_id";
export const SHIP_TO_ADDRESS_PHONE = "ship_to_address_phone";
export const SHIP_TO_COMPANY_ADDRESS_ID = "ship_to_company_address_id";
export const SHIP_TO_FOB = "ship_to_fob";
export const SHIP_TO_SHIPPING_ADDRESS = "ship_to_shipping_address";
export const SHIP_TO_LOCATION_ID = "ship_to_location_id";
export const SMALL_FILE_URL = "small_file_url";
export const SMALL_VERSION_CREATED_AT = "small_version_created_at";
export const SOLD_INVENTORY_ITEM = "sold_inventory_item";
export const START_DATE = "start_date";
export const SUBTOTAL = "subtotal";
export const SYNC_DATE = "sync_date";
export const TIER_TYPE_WARNING_LIMITS = "tier_type_warning_limits";
export const ULTIMATE_CONSIGNEE_ADDRESS = "ultimate_consignee_address";
export const FREIGHT_FORWARDER_ADDRESS = "freight_forwarder_address";
export const FREIGHT_FORWARDER_NAME = "freight_forwarder_name";
export const FREIGHT_FORWARDER_EMAIL = "freight_forwarder_email";
export const UPDATED_AT = "updated_at";
export const UPDATED_BY = "updated_by";
export const TENANT = "tenant";
export const TYPE = "type";
export const TOTAL = "total";
export const UUID = "uuid";
export const WARRANTY_CONSIDERATION = "warranty_consideration";
export const WARRANTY_REQUESTED = "warranty_requested";
export const YEAR = "year";

export const RETURN_TO = "return_to";
export const RETURN_TO_TYPE = "return_to_type";
export const RETURN_TO_FOB = "return_to_fob";
export const RETURN_TO_COMPANY_ID = "return_to_company_id";
export const RETURN_TO_COMPANY_ADDRESS_ID = "return_to_company_address_id";
export const RETURN_TO_SHIPPING_ADDRESS_ID = "return_to_shipping_address_id";
export const RETURN_TO_CUSTOMER_ADDRESS_ID = "return_to_customer_address_id";
export const RETURN_TO_LOCATION_ID = "return_to_location_id";
export const RETURN_TO_SHIPPING_ADDRESS = "return_to_shipping_address";
export const RETURN_TO_SHIPPING_METHOD = "return_to_shipping_method";

export const NAME = "name";
export const PHONE = "phone";
export const PHONE1 = "phone1";
export const EMAIL = "email";
export const PASSWORD = "password";
export const PASSWORD_CONFIRMATION = "password_confirmation";
export const PURCHASE_ORDER_BCC_EMAILS = "purchase_order_bcc_emails";

export const CARE_OF = "care_of";
export const COMPANY = "company";
export const COMPANY_NAME = "company_name";
export const CONTACT_NAME = "contact_name";
export const CONTACT_EMAIL = "contact_email";
export const COUNTRY = "country";
export const REGION = "region";
export const LINE1 = "line1";
export const LINE2 = "line2";
export const CITY = "city";
export const STATE = "state";
export const POSTAL_CODE = "postal_code";

export const RECEIVING_BANK_NAME = "receiving_bank_name";
export const INTERMEDIARY_BANK = "intermediary_bank";
export const ABA_ROUTING = "aba_routing";
export const ACH_ROUTING = "ach_routing";
export const SWIFT_CODE = "swift_code";
export const BENEFICIARY_ACCOUNT = "beneficiary_account";
export const IBAN = "iban";

export const ADDRESS_FIELDS = [
  CARE_OF,
  COMPANY_NAME,
  CONTACT_NAME,
  COUNTRY,
  LINE1,
  LINE2,
  CITY,
  STATE,
  POSTAL_CODE
];

export const CONDITIONS = {
  [NEW]: {
    abbrev: "NE",
    label: "New",
    default_warranty: "1 year"
  },
  [OVERHAULED]: {
    abbrev: "OH",
    label: "Overhauled",
    default_warranty: "1 year"
  },
  [REPAIRED]: {
    abbrev: "SV",
    label: "Repaired",
    default_warranty: "6 months"
  },
  [INSPECTED]: {
    abbrev: "BT",
    label: "Inspected",
    default_warranty: "30 days"
  },
  [AS_REMOVED]: {
    abbrev: "AR",
    label: "As Removed"
  },
  [BEYOND_REPAIR]: {
    abbrev: "BR",
    label: "Beyond Repair"
  }
};

export const CONDITIONS_WITH_SERVICEABLE = {
  ...CONDITIONS,
  [SERVICEABLE_TOOLING]: {
    abbrev: "SV",
    label: "Serviceable Tooling",
    default_warranty: "30 days"
  }
};

export const DISCREET = "discreet";

export const LABEL_SIZES = [
  { text: '4" x 6" (10.15cm x 15.25cm)', value: "4x6" },
  { text: '3" x 4" (7.62cm x 10.15cm)', value: "3x4" }
];

export const API_BASE =
  window.location.origin.includes("localhost") ||
  window.location.origin.includes("ngrok")
    ? process.env.API_BASE
    : `${window.location.origin}/v1`;



// WEBPACK FOOTER //
// ./app/constants.js